import styled from 'styled-components';
import {getToken} from '@tickchak/react-share/app';
import {row} from '../paragraphRow/ParagraphRow.css';

export {row};

export const staticText = styled.span`
    display: inline;
    white-space: pre-wrap;
    color: ${getToken('color.text.subtle')};
    cursor: default;
    user-select: none;
`;
